import { useAuth } from '../hooks/useAuth';

import { getRuntimeConfig } from '../config';

const API_BASE = getRuntimeConfig().apiBaseUrl;

interface FetchOptions {
  method?: string;
  body?: unknown;
  params?: Record<string, string>;
}

export function useApi() {
  const { token } = useAuth();

  async function apiFetch<T = unknown>(path: string, options: FetchOptions = {}): Promise<T> {
    const { method = 'GET', body, params } = options;

    let url = `${API_BASE}${path}`;
    if (params) {
      url += '?' + new URLSearchParams(params).toString();
    }

    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(url, {
      method,
      headers,
      body: body ? JSON.stringify(body) : undefined,
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: response.statusText }));
      throw new Error(error.error || `API error: ${response.status}`);
    }

    return response.json();
  }

  return { apiFetch };
}
